import { render, staticRenderFns } from "./edit-email.vue?vue&type=template&id=f53b6cde&scoped=true"
import script from "./edit-email.vue?vue&type=script&lang=js"
export * from "./edit-email.vue?vue&type=script&lang=js"
import style0 from "./edit-email.vue?vue&type=style&index=0&id=f53b6cde&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53b6cde",
  null
  
)

export default component.exports